import { render, staticRenderFns } from "./editshow.vue?vue&type=template&id=42a18f09&scoped=true&"
import script from "./editshow.vue?vue&type=script&lang=ts&"
export * from "./editshow.vue?vue&type=script&lang=ts&"
import style0 from "./editshow.vue?vue&type=style&index=0&id=42a18f09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a18f09",
  null
  
)

export default component.exports